var spoiler_default = {
  "fontElementMap": "Cg9OZ",
  "hideText": "y-Nuv",
  "onHoverText": "qSnI5",
  "hideBlock": "VP82G",
  "smallBlur": "_9dg1K",
  "mediumBlur": "yhKNs",
  "largeBlur": "ufL2X",
  "hideBlock_gallery": "QzLvd",
  "overlay": "xiFfG",
  "overlay_gallery": "s8jm-",
  "revealSpoilerBtn": "KWGEy",
  "isMobile": "OPN6X",
  "onHoverBtn": "BiO7x",
  "spoilerWrapper": "Th3Kk",
  "spoilerDescription": "-o5UH",
  "spoilerContainer": "DhNyR",
  "spoilerContainer_Gallery": "_4OvV6"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
